export default __webpack_public_path__ + "static/media/bg10.20b0e9ba.png";